import { NavLink, useNavigate } from "react-router-dom";
import {
  Building2,
  CalendarDays,
  LayoutDashboard,
  LogOut,
  Sparkles,
  Users,
} from "lucide-react";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";

export default function DashboardLayout({ title, children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin";

  const links = isAdmin
    ? [
        { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
        { to: "/admin/accounts", label: "Accounts", icon: Users },
        { to: "/admin/bookings", label: "Bookings", icon: CalendarDays },
      ]
    : [
        { to: "/owner", label: "Overview", icon: LayoutDashboard, end: true },
        { to: "/owner/venue", label: "My venue", icon: Building2 },
        { to: "/owner/reservations", label: "Reservations", icon: CalendarDays },
      ];

  return (
    <div className="min-h-screen bg-cream">
      <aside className="sticky top-0 z-30 bg-ink text-cream md:fixed md:inset-y-0 md:left-0 md:flex md:h-screen md:w-[260px] md:flex-col">
        <div className="flex items-center justify-between px-5 py-5 md:block">
          <Logo light />
          <p className="mt-4 hidden text-xs uppercase tracking-[0.22em] text-gold md:block">
            {isAdmin ? "Admin atelier" : "Venue studio"}
          </p>
        </div>
        <nav className="flex gap-2 overflow-x-auto px-3 pb-3 md:block md:flex-1 md:space-y-1 md:px-3">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              className={({ isActive }) =>
                `flex items-center gap-2 whitespace-nowrap rounded-2xl px-4 py-2.5 text-sm ${
                  isActive
                    ? "bg-gold text-ink"
                    : "text-cream/75 hover:bg-white/10 hover:text-cream"
                }`
              }
            >
              <link.icon size={16} />
              {link.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden px-5 py-6 md:mt-auto md:block">
          <div className="rounded-3xl bg-white/5 p-4">
            <p className="flex items-center gap-2 text-sm font-medium">
              <Sparkles size={14} className="text-gold" />
              {user?.name}
            </p>
            <p className="mt-1 text-xs text-cream/50">{user?.email}</p>
            <button
              className="mt-4 inline-flex items-center gap-2 text-xs text-blush hover:text-gold"
              onClick={() => {
                logout();
                navigate("/");
              }}
            >
              <LogOut size={14} /> Sign out
            </button>
          </div>
        </div>
      </aside>
      <div className="min-w-0 md:ml-[260px]">
        <header className="flex items-center justify-between border-b border-ink/5 px-4 py-5 sm:px-8">
          <div>
            <p className="text-xs uppercase tracking-[0.22em] text-rose">Aurelia</p>
            <h1 className="font-serif text-3xl">{title}</h1>
          </div>
          <NavLink to="/" className="btn-ghost hidden sm:inline-flex">
            View site
          </NavLink>
        </header>
        <div className="px-4 py-8 sm:px-8">{children}</div>
      </div>
    </div>
  );
}
